import html2canvas from "html2canvas";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../Firebase/config";
import { v4 as uuidv4 } from "uuid";

export const takeAndUploadScreenshot = async () => {
  try {
    // 🎯 Get the target div by its ID
    const targetDiv = document.getElementById(
      "capture-contract-section"
    );

    if (!targetDiv) {
      console.error("Target div not found!");
      return null;
    }

    // 🖼️ Capture only that specific element
    const canvas = await html2canvas(targetDiv, {
      useCORS: true,
      allowTaint: true,
      backgroundColor: null, // transparent background
      scale: 2, // for high-quality image
    });

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/png")
    );

    if (!blob) {
      console.error("Error creating screenshot blob");
      return null;
    }

    // 📁 Generate a unique filename
    const uniqueId = uuidv4();
    const fileName = `screenshot_${uniqueId}.png`;
    const file = new File([blob], fileName, { type: "image/png" });

    // ☁️ Upload to Firebase Storage
    const storageRef = ref(storage, `screenshots/${fileName}`);
    const snapshot = await uploadBytesResumable(storageRef, file);
    const downloadUrl = await getDownloadURL(snapshot.ref);

    console.log("✅ Screenshot uploaded:", downloadUrl);
    return downloadUrl;
  } catch (error) {
    console.error("Error capturing or uploading screenshot:", error);
    return null;
  }
};
